import _ from 'lodash';
const NOT_SIGNED_IN = 'Not signed in';
export var SessionPropsEnum;
(function (SessionPropsEnum) {
    SessionPropsEnum["userGUID"] = "userGUID";
    SessionPropsEnum["clusterName"] = "clusterName";
    SessionPropsEnum["clusterId"] = "clusterId";
    SessionPropsEnum["maskedJsessionId"] = "maskedJsessionId";
    SessionPropsEnum["userLocale"] = "userLocale";
    SessionPropsEnum["releaseVersion"] = "releaseVersion";
    SessionPropsEnum["blinkReleaseVersion"] = "blinkReleaseVersion";
    SessionPropsEnum["isEmbedded"] = "isEmbedded";
    SessionPropsEnum["isAdminUser"] = "isAdminUser";
    SessionPropsEnum["embraceRowCount"] = "embraceRowCount";
    SessionPropsEnum["licenseID"] = "licenseID";
    SessionPropsEnum["userPersona"] = "userPersona";
    SessionPropsEnum["hasDataManagementPrivileges"] = "hasDataManagementPrivileges";
    SessionPropsEnum["onboardingDataManagemenentFlag"] = "onboardingDataManagemenentFlag";
    SessionPropsEnum["hasSeenOnboarding"] = "hasSeenOnboarding";
    SessionPropsEnum["isAnswerV2Enabled"] = "isAnswerV2Enabled";
    SessionPropsEnum["isSaaSCluster"] = "isSaaSCluster";
    SessionPropsEnum["activeExperiments"] = "activeExperiments";
    SessionPropsEnum["isLiveboardEnabled"] = "isLiveboardEnabled";
    SessionPropsEnum["trialExpiryDate"] = "trialExpiryDate";
    SessionPropsEnum["planType"] = "planType";
    SessionPropsEnum["teamId"] = "teamId";
    SessionPropsEnum["isPinboardV2Enabled"] = "isPinboardV2Enabled";
    SessionPropsEnum["isOrgEnabled"] = "isOrgEnabled";
    SessionPropsEnum["orgId"] = "orgId";
    SessionPropsEnum["answerV2ExperienceEnabledOnMobile"] = "answerV2ExperienceEnabledOnMobile";
    SessionPropsEnum["isDataPanelV2Experience"] = "isDataPanelV2Experience";
})(SessionPropsEnum || (SessionPropsEnum = {}));
export var EventUpdatedPropertiesEnum;
(function (EventUpdatedPropertiesEnum) {
    EventUpdatedPropertiesEnum["navPath"] = "navPath";
    EventUpdatedPropertiesEnum["date"] = "date";
    EventUpdatedPropertiesEnum["pageContext"] = "pageContext";
    EventUpdatedPropertiesEnum["currentPage"] = "currentPage";
    EventUpdatedPropertiesEnum["previousPage"] = "previousPage";
})(EventUpdatedPropertiesEnum || (EventUpdatedPropertiesEnum = {}));
export class MixpanelSessionProperties {
    constructor(isEmbedded, getPath, getContextState, getCurrentPage, getPreviousPage, addEverywhereEventProps, isLiveboardEnabled, isOrgsEnabled) {
        this.isEmbedded = isEmbedded;
        this.getPath = getPath;
        this.getContextState = getContextState;
        this.getCurrentPage = getCurrentPage;
        this.getPreviousPage = getPreviousPage;
        this.addEverywhereEventProps = addEverywhereEventProps;
        this.isLiveboardEnabled = isLiveboardEnabled;
        this.isOrgsEnabled = isOrgsEnabled;
        this.properties = {
            userGUID: NOT_SIGNED_IN,
        };
        this.initStringSessionProps();
        this.initArraySessionProps();
        this.initBooleanSessionProps();
    }
    updateEventChangableSessionProperties() {
        const props = {};
        props[EventUpdatedPropertiesEnum.navPath] =
            !!this.getPath && this.getPath();
        props[EventUpdatedPropertiesEnum.date] = Date.now();
        props[EventUpdatedPropertiesEnum.pageContext] = this.getContextState();
        props[EventUpdatedPropertiesEnum.currentPage] =
            !!this.getCurrentPage && this.getCurrentPage();
        props[EventUpdatedPropertiesEnum.previousPage] =
            !!this.getPreviousPage && this.getPreviousPage();
        this.addEverywhereEventProps(props);
        Object.assign(this.properties, props);
    }
    updateSessionProperty(property, value, shouldAppend = false) {
        if (_.isArray(this.properties[property])) {
            if (_.includes(this.properties[property], value)) {
                return;
            }
            shouldAppend
                ? this.properties[property].push(value)
                : (this.properties[property] = [value]);
            return;
        }
        this.properties[property] = value;
    }
    updateSessionProperties(props) {
        _.forOwn(props, (value, key) => {
            this.updateSessionProperty(key, value);
        });
    }
    initStringSessionProps() {
        this.properties[SessionPropsEnum.clusterName] = NOT_SIGNED_IN;
        this.properties[SessionPropsEnum.clusterId] = NOT_SIGNED_IN;
        this.properties[SessionPropsEnum.maskedJsessionId] = NOT_SIGNED_IN;
        this.properties[SessionPropsEnum.releaseVersion] = NOT_SIGNED_IN;
        this.properties[SessionPropsEnum.blinkReleaseVersion] = NOT_SIGNED_IN;
    }
    initArraySessionProps() {
        this.properties[SessionPropsEnum.userLocale] = [NOT_SIGNED_IN];
        this.properties[SessionPropsEnum.activeExperiments] = [];
    }
    initBooleanSessionProps() {
        this.properties[SessionPropsEnum.isEmbedded] = this.isEmbedded;
        this.properties[SessionPropsEnum.isAdminUser] = NOT_SIGNED_IN;
        this.properties[SessionPropsEnum.isSaaSCluster] = NOT_SIGNED_IN;
        this.properties[SessionPropsEnum.isLiveboardEnabled] = this.isLiveboardEnabled;
        this.properties[SessionPropsEnum.isOrgEnabled] = this.isOrgsEnabled;
    }
    clearArraySessionProps(property) {
        if (_.isArray(this.properties[property])) {
            this.properties[property] = [];
        }
    }
    getProperties() {
        return this.properties;
    }
}
export function updatePropertiesWithEventName(properties, eventName) {
    properties.name = _.kebabCase(String(eventName));
    return properties;
}
//# sourceMappingURL=mixpanel-session-properties.js.map